import { useWSMutation } from "@ws-react-query";
import { queriesPayeeRows } from "@query";
import { deletePayeeEngagementByPayeeId } from "../../../services/payeeEngagement";
import { QUERY_PAYEE } from "../../payee/keys";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/useQueryPayeeRows";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../keys";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/useQueryPayeeRowsSummary";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENTS_LIST
} from "../../requirements/keys";

export interface DeletePayeeEngagementParams {
  payeeId: string;
  engagementId: string;
}

export const useMutationDeletePayeeEngagement = () => {
  return useWSMutation(
    async (params: DeletePayeeEngagementParams) => {
      return await deletePayeeEngagementByPayeeId(
        params.payeeId,
        params.engagementId
      );
    },
    {
      dependencies: [
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
        QUERY_PAYEE,
        QUERY_PAYEE_ROWS,
        QUERY_PAYEE_ROWS_SUMMARY,
        queriesPayeeRows.searchPayeeRows.queryKeyBase,
        QUERY_REQUIREMENTS_FULL_LIST,
        QUERY_REQUIREMENTS_FULL_LIST_SIZE,
        QUERY_REQUIREMENTS_LIST
      ]
    }
  );
};
